document.addEventListener('DOMContentLoaded', function () {
  const menu = document.getElementById('Details-HeaderMenu-2');
  if (!menu) return;

  menu.addEventListener('mouseenter', () => {
    menu.setAttribute('open', '');
  });

  menu.addEventListener('mouseleave', () => {
    menu.removeAttribute('open');
  });
});
